import React, { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

import Img from 'gatsby-image'

export default ({ children, steps, images }) => {
    const [ openSection, setOpenSection ] = useState(null);    


    steps = steps.map(step => ({
        image: images.find(image => image.contentful_id === step.figure) || null,
        ...step
    }))


    useEffect(() => {
        setOpenSection(steps[0])
    }, []);

    return (
        <Style>
            {openSection && openSection.image &&  (
                <Img className="demo__figure" Tag="figure" fluid={[
                    {
                        ...openSection.image.fluid,
                        media: '(min-width: 1160px)'
                    },
                    {
                        ...openSection.image.fluidMedium,
                        media: '(min-width: 760px)'
                    },
                    openSection.image.fluidSmall
                ]} alt={openSection.label} />
            )}
            <ul>
                { steps && steps.map((step, i) => (
                    <li key={i}>
                        <button 
                            type="button" 
                            disabled={openSection && openSection.label === step.label}
                            onClick={() => setOpenSection(step)}
                            >{step.label}</button>
                        {openSection && openSection.label === step.label && (
                            <div dangerouslySetInnerHTML={{__html: step.body}} />
                        )}
                    </li>
                ))}
            </ul>
        </Style>
    )
}


const Style = styled.article.attrs(props => ({
    className: 'demonstration'
}))`
    margin-top: 10vh;
    display: flex;
    flex-direction: column;
    grid-template-columns: 1.75fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 0 4vw;

    ${breakpoint('tablet')`
        display: grid;
    `}

    figure {
        grid-column: 1 / 2;
        animation-name: ${keyframes`
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        `};
        animation-delay: 0s;
        animation-duration: 300ms;
        animation-fill-mode: forwards;
        animation-iteration-count: 1;
        margin-bottom: 0;
    }

    ul {
        grid-column: 2 / 3;
        list-style: none;
        margin: 0;
        padding: 0;
    }


    button {
        appearance: none;
        padding: 0;
        background-color: transparent;
        border: none;
        text-align: left;
        font-weight: 600;
        font-size: 24px;
        letter-spacing: -0.84px;
        color: var(--red);
        cursor: pointer;
        line-height: 1.15;
        transition: color .2s ease;

        &:disabled, &:hover {
            color: var(--black);
        }
    }

    li + li {
        padding-top: 20px;
        border-top: 1px solid rgba(0,0,0,.15);
    }

    li > div {
        font-size: 14px;
        line-height: 1.2;

        > *:first-child {
            margin-top: 1em;
        }
        > *:last-child {
            margin-bottom: 1em;
        }
    }

`